import BoardListView from "components/view/board/list";

const BoardListPage = () => {
  return <BoardListView />;
};

export default BoardListPage;
